import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Home from "./pages/Home";
import Signup from './authentification/Signup';
import Login from './authentification/Login';
import { useEffect, useState } from 'react';
import PostPage from './pages/PostPage';
import Room from './pages/Room';
import Me from './pages/Me';
import Settings from './pages/Settings';
import Chat from './components/Chat';
import ProtectedRoute from './components/ProtectedRoutes';
import StudentMapPage from './pages/StudentMapPage';
import MessengerPage from './pages/MessengerPage';
import NotificationsPage from './pages/NotificationsPage';
import FriendsPage from './pages/FriendsPage';
import MessageBox from './components/MessageBox';
import ChatPage from './pages/ChatPage';
import UserProfile from './pages/Userprofile';
import SearchPage from './pages/SearchPage';
import CguPage from './pages/Cgupage';
import PrivacyPage from './pages/Privacypage';
import NotificationPrompt from './components/NotificationPrompt';
import Toast from './components/Toast';
import { subscribeUserToPush } from './Utils/push';



function App() {

    const [isMobile, setIsMobile] = useState(false);
    const [showNotifPrompt, setShowNotifPrompt] = useState(false);
    const [toast, setToast] = useState(null);

    useEffect(() => {
      const checkMobile = () => {
        const userAgent = /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(
          navigator.userAgent
        );
        const screenWidth = window.innerWidth <= 768;
        setIsMobile(userAgent || screenWidth);
      };

      checkMobile();
      window.addEventListener('resize', checkMobile);
      
      return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
      const token = localStorage.getItem('token');
      if (token && window.Notification && Notification.permission !== 'granted') {
          setShowNotifPrompt(true);
      }
    }, []);

    const handleSubscribe = async () => {
      if (window.Notification) {
        const permission = await Notification.requestPermission();
        if (permission === 'granted') {
          const success = await subscribeUserToPush();
          if (success) {
            setToast('Notifications activées !');
            setShowNotifPrompt(false);
          }
        } else {
          setToast('L\'activation des notifications est requise pour utiliser Agora.');
        }
      }
    };
        return (
      <Router>
        <div style={{ position: 'relative', minHeight: '100vh' }}>
          <Routes>
            {/* Routes Publiques */}
            <Route path="/" element={<Login />} />
            <Route path="/signup" element={<Signup />} />

            {/* Routes Protégées */}
            <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
            <Route path="/me" element={<ProtectedRoute><Me /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            <Route path="/post/:id" element={<ProtectedRoute><PostPage /></ProtectedRoute>} />
            <Route path="/room/:id" element={<ProtectedRoute><Room /></ProtectedRoute>} />
            <Route path="/chat/:id" element={<ProtectedRoute><ChatPage /></ProtectedRoute>} />
            <Route path="/profile/:id" element={<ProtectedRoute><UserProfile /></ProtectedRoute>} />
            <Route path="/search" element={<ProtectedRoute><SearchPage /></ProtectedRoute>} />

            {/* Mobile specific optional routes (handled in Home active switch but good for deep linking) */}
            {isMobile && (
              <>
                <Route path="/messenger" element={<ProtectedRoute><MessengerPage /></ProtectedRoute>} />
                <Route path="/students" element={<ProtectedRoute><StudentMapPage /></ProtectedRoute>} />
                <Route path="/notifications" element={<ProtectedRoute><NotificationsPage /></ProtectedRoute>} />
                <Route path="/friends" element={<ProtectedRoute><FriendsPage /></ProtectedRoute>} />
              </>
            )}

            <Route path="/cgu" element={<CguPage />} />
            <Route path="/politique-confidentialite" element={<PrivacyPage />} />
          </Routes>

          {showNotifPrompt && (
            <NotificationPrompt 
              onSubscribe={handleSubscribe} 
              onCancel={() => { setShowNotifPrompt(false); sessionStorage.setItem('notif_dismissed', 'true'); }} 
            />
          )}
          {toast && <Toast message={toast} setToast={setToast} />}
        </div>
      </Router>
    );
}


export default App;
